import {Component, Prop, Vue} from 'vue-property-decorator';
import {IPagedList} from '@/shared/api-client/models';
import {INominationListEntry} from '@/shared/api-client/models/nomination-list-entry';
import {IPagination} from '@/shared/models';
import {ApiClient} from '@/shared/api-client';
import {NominationFieldType} from '@/shared/models/nomination-field-type';
import {ArgumentValidator} from '@/shared/helpers';
import {NominationCustomFieldInputType} from '@/shared/models/nomination-custom-field-input-type';
import {friendlyDateTime} from '@/shared/filters';

interface IViewModel {

    pagedNominations: IPagedList<INominationListEntry>;
    pagination: IPagination;
    isInitialized: boolean;
    isLoading: boolean;
    state: ViewState;
    currentNomination?: INominationListEntry;
    currentField?: string;
}

interface ICustomField {

    type: NominationFieldType;

    fieldName: string;
}

type ViewState  = 'List' | 'ReadNomination';

@Component({
    filters: {
        friendlyDateTime
    }
})
export default class MyNomineesComponent extends Vue {

    @Prop() public enabledFields!: NominationFieldType[];
    @Prop() public customFieldInputTypes!: { [key: string]: NominationCustomFieldInputType; };
    @Prop() public translations!: { [key: string]: string; };

    public async created() {

        await this.refreshList();
    }

    public viewModel: IViewModel = {
        pagedNominations: {
            items: [],
            totalNbrOfItems: 0
        },
        pagination: {
            page: 1,
            pageSize: 15,
            total: -1
        },
        isInitialized: false,
        isLoading: false,
        state: 'List'
    };

    public customFields: ICustomField[] = [
        { type: 'CustomField1', fieldName: 'customField1'},
        { type: 'CustomField2', fieldName: 'customField2'},
        { type: 'CustomField3', fieldName: 'customField3'},
        { type: 'CustomField4', fieldName: 'customField4'},
        { type: 'CustomField5', fieldName: 'customField5'}
    ];

    private apiClient: ApiClient = new ApiClient();

    public isFieldEnabled(field: NominationFieldType): boolean {

        ArgumentValidator.notNullOrEmpty(field, `field`);

        return this.enabledFields.includes(field);
    }

    public get nbrOfEnabledFields(): number {

        return this.enabledFields.length;
    }

    public customFieldInputType(field: string): NominationCustomFieldInputType {

        ArgumentValidator.notNullOrEmpty(field, `field`);

        if (!this.customFieldInputTypes) {
            return 'SingleLineText';
        }

        if (!this.customFieldInputTypes[field]) {
            return 'SingleLineText';
        }

        return this.customFieldInputTypes[field];
    }

    public readNomination(nomination: INominationListEntry, field: string): void {

        ArgumentValidator.notNullOrEmpty(nomination, 'nomination');

        this.viewModel.state = 'ReadNomination';
        this.viewModel.currentNomination = nomination;
        this.viewModel.currentField = field;
    }

    public async pageChanged(page: number): Promise<void> {

        this.viewModel.pagination.page = page;

        await this.refreshList();
    }

    public listNominations(): void {

        this.viewModel.state = 'List';
        this.viewModel.currentNomination = undefined;
        this.viewModel.currentField = undefined;
    }

    private async refreshList(): Promise<void> {

        try {

            this.viewModel.isLoading = true;

            this.viewModel.pagedNominations = await this.apiClient.nomination.listMyNominees(
                this.viewModel.pagination
            );

            this.viewModel.pagination.total = this.viewModel.pagedNominations.totalNbrOfItems;

            this.viewModel.isInitialized = true;

        } finally {

            this.viewModel.isLoading = false;
        }
    }
}
